<script>
    import { getTecPassword } from '@/utils'

    export default {
        data: () => ({
            password: ""
        }),

        mounted() {
            this.password = getTecPassword()
        }
    }
</script>

<template>
    <section class='pa-2'>
        <v-sheet class='mx-auto pa-3 fluid__card'>
            <header class='fluid__card__header'>
                <h4 class='subtitle'>Senha</h4>
                <h3 class="display-1">{{ password }}</h3>
            </header>
        </v-sheet>
    </section>
</template>

<style scoped>
    .fluid__card {
        border: 1px solid #ccc;
    }

    .theme--dark.application .fluid__card {
        border-color: #000;
    }

    .fluid__card__header {
        display: flex;
        align-items: center;
        flex-direction: column;
    }
</style>
